import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { StatisticsRepository } from "../statistics.repository";
import { IRoundBet } from "../../core/round/interfaces";

@Injectable()
export class UpdateUserRoundBetRecordUseCase implements IUseCase<Partial<IRoundBet> & Pick<IRoundBet, "id">, void>{

    constructor(private statisticsRepository: StatisticsRepository) {
    }

    execute(bet: Partial<IRoundBet> & Pick<IRoundBet, "id">): void {
        this.statisticsRepository.updateUserRoundBetRecord(bet);
    }
}
